"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MNexSpikeBrand = void 0;
exports.MNexSpikeBrand = {
    "color-brand-50": "#E8F2F1",
    "color-brand-100": "#E0EEED",
    "color-brand-200": "#D1E5E4",
    "color-brand-300": "#A1CECB",
    "color-brand-400": "#7ABAB6",
    "color-brand-500": "#50A7A1",
    "color-brand-600": "#26928A",
    "color-brand-700": "#008077",
    "color-brand-800": "#026760",
    "color-brand-900": "#054F4A",
    "color-brand-950": "#003534",
    "color-brand-secondary-50": "#EFF4FB",
    "color-brand-secondary-100": "#DFE9F6",
    "color-brand-secondary-200": "#C7D8EF",
    "color-brand-secondary-300": "#86D2F3",
    "color-brand-secondary-400": "#62CDF8",
    "color-brand-secondary-500": "#2AACE2",
    "color-brand-secondary-600": "#1880B9",
    "color-brand-secondary-700": "#0E6896",
    "color-brand-secondary-800": "#10587C",
    "color-brand-secondary-900": "#134967",
    "color-brand-secondary-950": "#01283C"
};
//# sourceMappingURL=MNexSpikeBrand.js.map